import { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { openNotification } from "../../utils/saveFile";
import apiDocumentos from "../../api/Documentos/api-documentos";
import { DownloadFile } from "../../utils/DownloadFile";

interface IProps {
  state: any;
  visualizar: boolean;
  setVisualizar: any;
  tipo?: any;
  tipoDocumento?: any;
}

export const ModalVisualizarDocumentos: React.FC<IProps> = (props: IProps) => {
  const { documento } = props.state;
  const [dataDocumento, setDataDocumento] = useState({ pdf: "" });
  const checkIsMobile = () => {
    if (typeof window === "undefined") return false;
    return (
      window.innerWidth <= 992 ||
      "ontouchstart" in window ||
      (navigator && navigator.maxTouchPoints > 0) ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "")
    );
  };
  const [isMobile, setIsMobile] = useState<boolean>(checkIsMobile());

  useEffect(() => {
    const handleResize = () => setIsMobile(checkIsMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (props.visualizar) {
      verDocumentacion();
    }
  }, [props.visualizar]);

  const verDocumentacion = async () => {
    if (documento !== undefined && documento !== null && documento !== "") {
      try {
        let response;

        if (props.tipoDocumento === 'terminos') {
          response = await apiDocumentos.consultarArchivosEstaticos(documento)
        } else if (props.tipoDocumento === 'politicasUso') {
          response = await apiDocumentos.consultarArchivosEstaticos(documento)
        } else {
          response = await apiDocumentos.consultarArchivo(documento)
        }

        let mimetype;
        const extension = String(documento).split(".").pop()?.toLowerCase() ?? "";
        let file, fileURL;
        switch (extension) {
          case "pdf":
            mimetype = "application/pdf";
            file = new Blob([response.data], {
              type: mimetype,
            });
            fileURL = URL.createObjectURL(file);
            return setDataDocumento({
              ...dataDocumento,
              pdf: fileURL,
            });
          case "doc":
          case "docx":
            mimetype = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            file = new Blob([response.data], {
              type: mimetype,
            });
            fileURL = URL.createObjectURL(file);
            return setDataDocumento({
              ...dataDocumento,
              pdf: fileURL,
            });
          case "xls":
          case "xlsx":
            mimetype = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            file = new Blob([response.data], {
              type: mimetype,
            });
            fileURL = URL.createObjectURL(file);
            return setDataDocumento({
              ...dataDocumento,
              pdf: fileURL,
            });
          default:
            return DownloadFile(documento);
        }

      } catch (error) {
        console.log(error);
      }
    } else {
      return openNotification({
        titulo: "Error",
        descripcion: "Ups, no se ha encontrado el archivo",
        placement: "bottomRight",
      });
    }
  };

  const onCancel = () => {
    props.setVisualizar(false)
    return setDataDocumento({ ...dataDocumento, pdf: '' });
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      title={`Previsualización: ${props.state.documento}`}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={isMobile ? "95vw" : 1200}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div>
        {dataDocumento.pdf !== "" ? (
          isMobile ? (
            <div style={{ textAlign: "center", padding: "32px 16px" }}>
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  margin: "0 auto 16px",
                  borderRadius: "50%",
                  backgroundColor: "#eff6ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#0b2d4f",
                }}
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <p style={{ fontSize: "16px", color: "#0b2d4f", fontWeight: 700, marginBottom: "6px" }}>
                Documento disponible
              </p>
              <p
                style={{
                  fontSize: "13px",
                  color: "#64748b",
                  marginBottom: "20px",
                  wordBreak: "break-all",
                  maxWidth: "420px",
                  margin: "0 auto 20px",
                }}
              >
                {props.state.documento}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  maxWidth: "320px",
                  margin: "0 auto",
                }}
              >
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#0b2d4f",
                    borderColor: "#0b2d4f",
                    height: "44px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                  onClick={() => window.open(dataDocumento.pdf, "_blank")}
                >
                  Abrir documento en pantalla completa
                </Button>
                <Button
                  style={{
                    height: "44px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                  onClick={() => DownloadFile(documento)}
                >
                  Descargar archivo
                </Button>
              </div>
            </div>
          ) : (
            <embed src={`${dataDocumento.pdf}`} width="100%" height="575px" />
          )
        ) : null}
      </div>
    </Modal>
  );
};
